import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import '../../assets/styles/components/instrument/historical-mobile.scss';


class FundHistorical extends Component{
    constructor(props){
        super(props)
    }

    render(){
        const { fundListoricalList , language} = this.props
        return(
            <div className='fund-historical-container'>
            <div className='fund-historical-head'>
                    <div>{language.common_date}</div>
                    <div>{language.common_funds_nav}</div>
                    <div>{language.mobile_funds_day_chg}</div>
            </div>
            <div className='fund-historical-table-body'>
                { fundListoricalList ? fundListoricalList.map(item => {
                return (
                    <div className='fund-historical-body-item' key={item.date}>
                    <div className='fund-historical-body-date'>{item.date}</div>
                    <div className='fund-historical-body-nav'>{item.nav}</div>
                    <div className={classnames('fund-historical-body-chg', item.color)}>{item.value}</div>
                    </div>
                )
                }) :  <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' ,minHeight:'208px', width :'100%'}} /> }
            </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        language: state.app.language,
      }),
    dispatch => ({
    })
)(FundHistorical)

